module.exports = __webpack_public_path__ + "img/home.30ceb439.jpg";